module.exports = __webpack_public_path__ + "static/Sonyax53-114e176bd5ece280368507299488a61e.png";